import BasicContentBackToTopButton from './BasicContentBackToTopButton';

export default BasicContentBackToTopButton;
